import React from 'react';
import styled, { withTheme } from 'styled-components';
// @ts-ignore
import logo from '../../assets/images/new_shippit_logo.svg';
import Media from './styled/Media';
import {
  isDisplayedInIframe,
  logoAlignment,
  headerLogo,
  headerBg,
} from './styled/Theme';
import { Theme } from '../../types/theme';

const ThemeHeader = styled.header`
  background: ${({ theme }) => headerBg(theme)};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: ${({ theme }) => logoAlignment(theme)};
  height: 4.375rem;
  padding: 0 1.25rem;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 5;

  @media ${Media.mobile} {
    height: 3.75rem;
  }
`;

const Logo = styled.img`
  height: 3rem;

  @media ${Media.mobile} {
    height: 70%;
  }
`;

type Props = {
  theme: Theme;
};

const Header = ({ theme }: Props) =>
  !isDisplayedInIframe(theme) ? (
    <ThemeHeader className="header">
      <Logo src={headerLogo(theme) ? headerLogo(theme) : logo} alt="logo" />
    </ThemeHeader>
  ) : null;

export default withTheme(Header);
